import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../lib/firebase';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogDescription
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Mail, Loader2, CheckCircle2, ArrowRight, ShieldEllipsis } from 'lucide-react'; // Ícone corrigido
import { toast } from 'sonner';

const Forgot = ({ isOpen, onOpenChange }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Digite seu e-mail cadastrado.");

    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
      toast.success("Link de recuperação enviado!");
    } catch (error) {
      console.error(error);
      toast.error("Erro ao enviar e-mail. Verifique os dados.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(val) => {
      onOpenChange(val);
      if(!val) setTimeout(() => setSent(false), 300);
    }}>
      <DialogContent className="rounded-[2.5rem] border-none p-10 max-w-md bg-white shadow-2xl overflow-hidden">
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-orange-500/10 rounded-full blur-3xl pointer-events-none" />

        <DialogHeader className="text-left relative z-10">
          <div className="w-16 h-16 bg-orange-50 rounded-2xl flex items-center justify-center mb-6 shadow-inner text-orange-600">
            {sent ? <CheckCircle2 size={32} /> : <ShieldEllipsis size={32} />}
          </div>
          <DialogTitle className="text-3xl font-black uppercase italic tracking-tighter text-slate-900 leading-none">
            {sent ? "E-mail Enviado!" : "Recuperar Senha"}
          </DialogTitle>
          <DialogDescription className="text-[11px] font-bold uppercase italic text-slate-400 mt-2 tracking-widest leading-relaxed">
            {sent 
              ? "Verifique sua caixa de entrada para redefinir sua conta." 
              : "Enviaremos um link de segurança para o seu e-mail."}
          </DialogDescription>
        </DialogHeader>

        {!sent ? (
          <form onSubmit={handleResetPassword} className="space-y-6 mt-6 relative z-10">
            <div className="space-y-2">
              <Label className="text-[10px] font-black uppercase ml-2 text-slate-400 italic">E-mail de Cadastro</Label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={18} />
                <Input 
                  type="email" 
                  placeholder="EXEMPLO@EMAIL.COM" 
                  className="h-16 pl-12 rounded-2xl bg-slate-50 border-none font-bold shadow-inner"
                  value={email}
                  onChange={(e) => setEmail(e.target.value.toLowerCase())}
                  required
                />
              </div>
            </div>

            <Button type="submit" disabled={loading} className="w-full h-16 bg-slate-900 hover:bg-slate-800 text-white font-black rounded-2xl uppercase italic text-xs shadow-xl flex items-center gap-3">
              {loading ? <Loader2 className="animate-spin" /> : <>ENVIAR LINK <ArrowRight size={18}/></>}
            </Button>
          </form>
        ) : (
          <div className="mt-8 space-y-4 relative z-10">
            <Button onClick={() => onOpenChange(false)} className="w-full h-16 bg-orange-500 hover:bg-orange-600 text-white font-black rounded-2xl uppercase italic text-xs shadow-xl">
              VOLTAR PARA O LOGIN
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Forgot;